import type { Component, ShallowRef } from "vue";
import type { Router } from "vue-router";

export function syncLayoutWithRoute(
  router: Router,
  layout: ShallowRef<Component | string>,
  layouts: Record<string, Component>,
): void {
  router.afterEach((to, _from, failure) => {
    // A failed navigation keeps the current page, so it must keep its layout.
    // Otherwise the page loses the header that its breadcrumb Teleport targets.
    if (failure) {
      return;
    }
    layout.value = layouts[to.meta.layout as string] ?? "div";
  });
}
